/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CreateAndUpdateOrganisations } from '@coin/shared/core/util-models-v2';
import { CreateAndUpdateOrganisationsStatus } from '@coin/shared/core/util-models-v2';
import { DetailedEmployee } from '@coin/shared/core/util-models-v2';
import { EmployeeMetaInformation } from '@coin/shared/core/util-models-v2';
import { GetEmployeesByGidsQuery } from '@coin/shared/core/util-models-v2';
import { OrganisationManagementActivityStreamQuery } from '@coin/shared/core/util-models-v2';
import { OrganisationManagementEmployeesEmployee } from '@coin/shared/core/util-models-v2';
import { OrganisationManagementOrganisationsOrganisation } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeeRole } from '@coin/shared/core/util-models-v2';
import { PageOfOrganisationInfo } from '@coin/shared/core/util-models-v2';
import { PageOfOrganisationManagementActivityStream } from '@coin/shared/core/util-models-v2';
import { PageOfOrganisationManagementEmployeesEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfPositionsPosition } from '@coin/shared/core/util-models-v2';
import { PositionsPosition } from '@coin/shared/core/util-models-v2';
import { RuleSet } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface CreateAndUpdateOrganisationsOrganisationsParams {
  createAndUpdateOrganisations?: CreateAndUpdateOrganisations;
}

export interface GetByQueryOrganisationsParams {
  validOn?: string;
}

export interface GetByQueryPositionsParams {
  /** The OrganisationId to which the positions records are assigned */
  organisationId?: string;
  /** Filter for given position title */
  title?: string;
  /** The date on which the position records are valid. */
  validOn?: string;
  /** The date on which the position records are valid. */
  validTo?: string;
  isDistinct?: boolean;
  validOnDate?: string;
  validToDate?: string;
}

export interface GetEmployeeCustomMetaInformationEmployeesParams {
  employeeId: string;
  validOn?: string;
}

export interface GetFutureOrganisationsOrganisationsParams {
  id: string;
  validOn: string;
}

export interface GetOrganisationInformationByQueryOrganisationsParams {
  orgType?: string;
  orgClass?: string;
  orgUnit?: string;
  validOn?: string;
  page?: number;
  size?: number;
}

export interface GetOrganisationsByRuleSetOrganisationsParams {
  ruleSet?: RuleSet;
}

export interface OrganisationManagementCustomerQueryByGidsEmployeesParams {
  getEmployeesByGidsQuery?: GetEmployeesByGidsQuery;
}

export interface OrganisationManagementCustomerQueryEmployeesParams {
  validOn?: string;
  searchString?: string;
  includeInvalidContractStatusAndWorkforceTypes?: boolean;
  page?: number;
  size?: number;
}

export interface QueryActivityStreamParams {
  page?: number;
  size?: number;
  organisationManagementActivityStreamQuery?: OrganisationManagementActivityStreamQuery;
}

export interface QueryDetailsEmployeesParams {
  employeeId: string;
  validOn?: string;
}

export interface QueryEmployeeRoleParams {
  validOn?: string;
  employeeRoleClass?: string;
  roleType?: string;
  page?: number;
  size?: number;
}

export interface SearchPositionsParams {
  search: string;
  validOn?: string;
  page?: number;
  size?: number;
}

@Injectable({
  providedIn: 'root'
})
export class OrganisationManagementCustomerService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * Start process to create and update organisations and all their related information.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createAndUpdateOrganisationsOrganisations(
    requestParameters?: CreateAndUpdateOrganisationsOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<CreateAndUpdateOrganisationsStatus>;
  public createAndUpdateOrganisationsOrganisations(
    requestParameters?: CreateAndUpdateOrganisationsOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<CreateAndUpdateOrganisationsStatus>>;
  public createAndUpdateOrganisationsOrganisations(
    requestParameters?: CreateAndUpdateOrganisationsOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<CreateAndUpdateOrganisationsStatus>>;
  public createAndUpdateOrganisationsOrganisations(
    requestParameters?: CreateAndUpdateOrganisationsOrganisationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-management/customer/v1/organisations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createAndUpdateOrganisations,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Get a list of all organizations that are valid at a given date.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getByQueryOrganisations(
    requestParameters?: GetByQueryOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<OrganisationManagementOrganisationsOrganisation>>;
  public getByQueryOrganisations(
    requestParameters?: GetByQueryOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<OrganisationManagementOrganisationsOrganisation>>>;
  public getByQueryOrganisations(
    requestParameters?: GetByQueryOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<OrganisationManagementOrganisationsOrganisation>>>;
  public getByQueryOrganisations(
    requestParameters?: GetByQueryOrganisationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/customer/v1/organisations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { ValidOn: requestParameters?.validOn }
    });
  }

  /**
   * Get a list of all Position that are assigned to an given organisation and valid at a given date.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getByQueryPositions(
    requestParameters?: GetByQueryPositionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<PositionsPosition>>;
  public getByQueryPositions(
    requestParameters?: GetByQueryPositionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<PositionsPosition>>>;
  public getByQueryPositions(
    requestParameters?: GetByQueryPositionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<PositionsPosition>>>;
  public getByQueryPositions(requestParameters?: GetByQueryPositionsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/customer/v1/positions`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        OrganisationId: requestParameters?.organisationId,
        Title: requestParameters?.title,
        ValidOn: requestParameters?.validOn,
        ValidTo: requestParameters?.validTo,
        IsDistinct: requestParameters?.isDistinct,
        ValidOnDate: requestParameters?.validOnDate,
        ValidToDate: requestParameters?.validToDate
      }
    });
  }

  /**
   * Get employee details of given employee id
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEmployeeCustomMetaInformationEmployees(
    requestParameters?: GetEmployeeCustomMetaInformationEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeMetaInformation>;
  public getEmployeeCustomMetaInformationEmployees(
    requestParameters?: GetEmployeeCustomMetaInformationEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeMetaInformation>>;
  public getEmployeeCustomMetaInformationEmployees(
    requestParameters?: GetEmployeeCustomMetaInformationEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeMetaInformation>>;
  public getEmployeeCustomMetaInformationEmployees(
    requestParameters?: GetEmployeeCustomMetaInformationEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('getEmployeeCustomMetaInformationEmployees', { employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/customer/v1/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/information`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { validOn: requestParameters?.validOn }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getFutureOrganisationsOrganisations(
    requestParameters?: GetFutureOrganisationsOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<OrganisationManagementOrganisationsOrganisation>>;
  public getFutureOrganisationsOrganisations(
    requestParameters?: GetFutureOrganisationsOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<OrganisationManagementOrganisationsOrganisation>>>;
  public getFutureOrganisationsOrganisations(
    requestParameters?: GetFutureOrganisationsOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<OrganisationManagementOrganisationsOrganisation>>>;
  public getFutureOrganisationsOrganisations(
    requestParameters?: GetFutureOrganisationsOrganisationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const validOn = requestParameters?.validOn;
    this.checkRequired('getFutureOrganisationsOrganisations', { id, validOn });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/customer/v1/organisations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/future`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { ValidOn: validOn }
    });
  }

  /**
   * Get a page result of organisation infos
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getOrganisationInformationByQueryOrganisations(
    requestParameters?: GetOrganisationInformationByQueryOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfOrganisationInfo>;
  public getOrganisationInformationByQueryOrganisations(
    requestParameters?: GetOrganisationInformationByQueryOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfOrganisationInfo>>;
  public getOrganisationInformationByQueryOrganisations(
    requestParameters?: GetOrganisationInformationByQueryOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfOrganisationInfo>>;
  public getOrganisationInformationByQueryOrganisations(
    requestParameters?: GetOrganisationInformationByQueryOrganisationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/customer/v1/organisations/organisation-list`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        OrgType: requestParameters?.orgType,
        OrgClass: requestParameters?.orgClass,
        OrgUnit: requestParameters?.orgUnit,
        ValidOn: requestParameters?.validOn,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Start process to create and update organisations and all their related information.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getOrganisationsByRuleSetOrganisations(
    requestParameters?: GetOrganisationsByRuleSetOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<OrganisationManagementOrganisationsOrganisation>>;
  public getOrganisationsByRuleSetOrganisations(
    requestParameters?: GetOrganisationsByRuleSetOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<OrganisationManagementOrganisationsOrganisation>>>;
  public getOrganisationsByRuleSetOrganisations(
    requestParameters?: GetOrganisationsByRuleSetOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<OrganisationManagementOrganisationsOrganisation>>>;
  public getOrganisationsByRuleSetOrganisations(
    requestParameters?: GetOrganisationsByRuleSetOrganisationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-management/customer/v1/organisations/rules`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Get a list of all employees that are valid at a given date and contains the search string.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationManagementCustomerQueryByGidsEmployees(
    requestParameters?: OrganisationManagementCustomerQueryByGidsEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<OrganisationManagementEmployeesEmployee>>;
  public organisationManagementCustomerQueryByGidsEmployees(
    requestParameters?: OrganisationManagementCustomerQueryByGidsEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<OrganisationManagementEmployeesEmployee>>>;
  public organisationManagementCustomerQueryByGidsEmployees(
    requestParameters?: OrganisationManagementCustomerQueryByGidsEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<OrganisationManagementEmployeesEmployee>>>;
  public organisationManagementCustomerQueryByGidsEmployees(
    requestParameters?: OrganisationManagementCustomerQueryByGidsEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-management/customer/v1/employees/gids`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.getEmployeesByGidsQuery,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Get a list of all employees that are valid at a given date and contains the search string.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public organisationManagementCustomerQueryEmployees(
    requestParameters?: OrganisationManagementCustomerQueryEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfOrganisationManagementEmployeesEmployee>;
  public organisationManagementCustomerQueryEmployees(
    requestParameters?: OrganisationManagementCustomerQueryEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfOrganisationManagementEmployeesEmployee>>;
  public organisationManagementCustomerQueryEmployees(
    requestParameters?: OrganisationManagementCustomerQueryEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfOrganisationManagementEmployeesEmployee>>;
  public organisationManagementCustomerQueryEmployees(
    requestParameters?: OrganisationManagementCustomerQueryEmployeesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/customer/v1/employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        ValidOn: requestParameters?.validOn,
        SearchString: requestParameters?.searchString,
        IncludeInvalidContractStatusAndWorkforceTypes: requestParameters?.includeInvalidContractStatusAndWorkforceTypes,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Gets the activity stream for organisation management.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryActivityStream(
    requestParameters?: QueryActivityStreamParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfOrganisationManagementActivityStream>;
  public queryActivityStream(
    requestParameters?: QueryActivityStreamParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfOrganisationManagementActivityStream>>;
  public queryActivityStream(
    requestParameters?: QueryActivityStreamParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfOrganisationManagementActivityStream>>;
  public queryActivityStream(requestParameters?: QueryActivityStreamParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/organisation-management/customer/v1/activity-stream/organisations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size },
      body: requestParameters?.organisationManagementActivityStreamQuery,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * Get employee details of given employee id
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryDetailsEmployees(
    requestParameters?: QueryDetailsEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<DetailedEmployee>;
  public queryDetailsEmployees(
    requestParameters?: QueryDetailsEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<DetailedEmployee>>;
  public queryDetailsEmployees(
    requestParameters?: QueryDetailsEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<DetailedEmployee>>;
  public queryDetailsEmployees(requestParameters?: QueryDetailsEmployeesParams, ...args: RequestArgs): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('queryDetailsEmployees', { employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/customer/v1/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { validOn: requestParameters?.validOn }
    });
  }

  /**
   * Get a list of all employees that are valid at a given date and contains the search string.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEmployeeRole(
    requestParameters?: QueryEmployeeRoleParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeeRole>;
  public queryEmployeeRole(
    requestParameters?: QueryEmployeeRoleParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeeRole>>;
  public queryEmployeeRole(
    requestParameters?: QueryEmployeeRoleParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeeRole>>;
  public queryEmployeeRole(requestParameters?: QueryEmployeeRoleParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/customer/v1/employee-role`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        ValidOn: requestParameters?.validOn,
        EmployeeRoleClass: requestParameters?.employeeRoleClass,
        RoleType: requestParameters?.roleType,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Get a list of all primary positions that are valid at a given time and where the employee information (gid, firstname, lastname) contains the search query
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public searchPositions(
    requestParameters?: SearchPositionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfPositionsPosition>;
  public searchPositions(
    requestParameters?: SearchPositionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfPositionsPosition>>;
  public searchPositions(
    requestParameters?: SearchPositionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfPositionsPosition>>;
  public searchPositions(requestParameters?: SearchPositionsParams, ...args: RequestArgs): Observable<any> {
    const search = requestParameters?.search;
    this.checkRequired('searchPositions', { search });
    return this.sendRequest(args, {
      method: 'get',
      path: `/organisation-management/customer/v1/positions/employees/search`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Search: search,
        ValidOn: requestParameters?.validOn,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }
}
